var _a;
import { DocumentStatus } from '@account-verification-frontend/types';
export var documentStatus = (_a = {},
    _a[DocumentStatus.REQUIRED] = 'DOCUMENT_STATUS_REQUIRED',
    _a[DocumentStatus.VERIFIED] = 'DOCUMENT_STATUS_VERIFIED',
    _a[DocumentStatus.REJECTED] = 'DOCUMENT_STATUS_REJECTED',
    _a[DocumentStatus.PENDING] = 'DOCUMENT_STATUS_PENDING',
    _a[DocumentStatus.SUBMITTED] = 'DOCUMENT_STATUS_SUBMITTED',
    _a[DocumentStatus.NOT_UPLOADED] = 'DOCUMENT_STATUS_NOT_UPLOADED',
    _a);
//# sourceMappingURL=constants.js.map